import { useAppStore, type DemoRole, type StoreUser } from '../stores/app';

const DEMO_SESSION_KEY = 'pm-demo-session';

export const DEMO_TENANT_CONFIG = {
  tenantId: 'c4444444-4444-4444-4444-444444444444',
  leaseId: 'e4444444-4444-4444-4444-444444444444',
  companyName: 'Sunrise Coffee Roasters',
} as const;

export function saveDemoSession(role: DemoRole): void {
  localStorage.setItem(
    DEMO_SESSION_KEY,
    JSON.stringify({
      role,
      expiresAt: Date.now() + 24 * 60 * 60 * 1000,
    }),
  );
}

export function loadDemoSession(): DemoRole | null {
  const saved = localStorage.getItem(DEMO_SESSION_KEY);
  if (!saved) return null;
  const { role, expiresAt } = JSON.parse(saved) as {
    role: DemoRole;
    expiresAt: number;
  };
  if (Date.now() > expiresAt) {
    localStorage.removeItem(DEMO_SESSION_KEY);
    return null;
  }
  return role;
}

export function clearDemoSession(): void {
  localStorage.removeItem(DEMO_SESSION_KEY);
}

export function activateDemoMode(role: DemoRole): void {
  const store = useAppStore();
  saveDemoSession(role);
  store.isDemoMode = true;
  store.demoRole = role;
  store.isAuthenticated = true;
  store.user = {
    firstName: 'Demo',
    lastName: role.charAt(0).toUpperCase() + role.slice(1),
    primaryEmailAddress: {
      emailAddress: `${role}@demo.linbrandon.com`,
    },
  } as StoreUser;
}

export function exitDemoMode(): void {
  const store = useAppStore();
  clearDemoSession();
  store.isDemoMode = false;
  store.demoRole = null;
  store.isAuthenticated = false;
  store.user = null;
}
